<template>
    <div  v-if="Object.keys(shop).length !==0" class="detail-shop-info">
        <div class="shop-top">
            <img :src="shop.logo">
            <span class="title">{{shop.name}}</span>
        </div>
        <div class="shop-middle">
            <div class="shop-middle-item shop-middle-left">
                <div class="info-sells">
                    <div class="sells-count">
                        {{shop.sells}}
                    </div>
                    <div class="sells-text">总销量</div>
                </div>
                <div class="info-goods">
                    <div class="goods-count">
                        {{shop.goodsCount}}
                    </div>
                    <div class="goods-text">全部宝贝</div>
                </div>
            </div>
            <div class="shop-middle-item shop-middle-right">
                <table>
                    <tr v-for="(item,index) in shop.score" :key="index">
                        <td>{{item.name}}</td>
                        <td class="score">{{item.score}}</td>
                        <td>{{item.isBetter ? '高':'低'}}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="shop-bottom">
            <div class="enter-shop">进店逛逛</div>
        </div>
<!--        <div>{{shop}}</div>-->
    </div>
</template>

<script>
    export default {
        name: "DetailShopInfo",
        props:{
            shop:{
                type:Object,
            }
        },
        data(){
            return{
                sellCountFilter:0,
            }
        }
    }
</script>

<style scoped>
.detail-shop-info{
    padding: 25px 8px;
   border-bottom: 5px solid #2f5f8;

}
    .shop-top{
        line-height: 45px;
        display: flex;
        align-items: center;
    }
    .shop-top img{
        width:45px;
        height: 45px;
        border-radius: 50%;
        border: 1px solid rgba(0,0,0,.1);

    }
    .shop-top .title{
        margin-left: 10px;
        vertical-align: center;
    }
    .shop-middle{
        margin-top: 15px;
        display: flex;
        align-items: center;
    }
    .shop-middle-left{
        flex: 1;
    }
    .shop-middle-left{
        display: flex;
        justify-content: space-evenly;
        color: #333;
        text-align: center;
        border-right: 1px solid rgba(0,0,0,.1);
    }
    .sells-count,.goods-count{
        font-size: 18px;
    }
    .sells-text, .goods-text{
        margin-top: 10px;
        font-size: 12px;
    }
    .shop-middle-right{
        font-size: 13px;
        color: #333;
    }
    .shop-middle-right tabble{
        width: 120px;
        margin-left: 30px;
    }
    .shop-middle-right table td{
        padding:5px 0;
    }
    .shop-middel-right .score{
        color: #5ea732;
    }
    .shop-middle-right .better-more span{
        background-color: #f13e3a;
    }
    .shop-bottom{
        text-align: center;
        margin-top: 10px;
    }
    .enter-shop{
        display: inline-block;
        font-size: 14px;
        background-color: #f2f5f8;
        width: 150px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        border-radius: 10px;
    }
</style>